<template>
  <div>
    <div class="content">
      <syllogePage></syllogePage>
    </div>
  </div>
</template>
<script>
import syllogePage from './pageList/syllogePage'
export default {
  components: {
    syllogePage
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
}
</script>
<style scoped lang="less">

</style>
